<header class="ph">
  <div class="ph-main">
    @if (section) {
      <div class="crumbs">
        <span>{{ section }}</span>
        <span class="material-symbols-outlined">chevron_right</span>
        <span class="current">{{ title }}</span>
      </div>
    }
    <h1>{{ title }}</h1>
    @if (subtitle) {
      <p class="sub">{{ subtitle }}</p>
    }
  </div>
  <div class="ph-actions"><ng-content></ng-content></div>
</header>
